module.exports = __webpack_public_path__ + "static/media/search.c447bf6d.svg";